/*global google*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import Message from '../../Common/Message/Message';
import editIcon from '../../../images/icons/edit-white.svg';
import './Star.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Star extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            client: {
                id: null,
                daily_email: false,
                client_name: '',
                client_email: '',
                client_phone: '',
                billing_contact: '',
                billing_address_1: '',
                billing_address_2: '',
                billing_city: '',
                billing_country: 'US',
                billing_state: 'AL',
                billing_zip: '',
                referred_by: '',
                donation: false,
                donation_text: '',
                donation_email: '',
                collect_cust_info: false,
                allow_will_call: false,
                allow_callcenter_refund: false,
                allow_callcenter_exchange: false,
                url_short_name: '',
                payout_option: 'check-at-close',
                payout_frequency: 'daily',
            },
            validation: {
                client_name: {
                    valid: null,
                    msg: ''
                },
                billing_address_1: {
                    valid: null,
                    msg: ''
                },
                client_email: {
                    valid: null,
                    msg: ''
                },
                client_phone: {
                    valid: null,
                    msg: ''
                },
                billing_city: {
                    valid: null,
                    msg: ''
                },
                billing_country: {
                    valid: true,
                    msg: ''
                },
                billing_state: {
                    valid: true,
                    msg: ''
                },
                billing_contact: {
                    valid: null,
                    msg: ''
                },
                billing_zip: {
                    valid: null,
                    msg: ''
                }
            },
            isReadyToSubmit : false,
            isDisabled: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
            printers: [],
            new_printer: {
                name: '',
                ip_address: '',
            },
            isShowAddPrinter: false,
            selectedPrinter: '',
        };
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    componentDidMount = () => {
        this.getPrinters();
        if (localStorage.getItem('defaultStarPrinter') && localStorage.getItem('defaultStarPrinter') !== '') {
            this.setSelectedPrinter(localStorage.getItem('defaultStarPrinter'));
        }
    }

    componentWillReceiveProps(props) {
        if(props.isUpdateClient){
            //this.updateClient();
        }
    }

    getPrinters = async () => {
        this.setMessage('','','loading');
        let printers = this.state.printers;
        try {
            const getPrintersResponse = await getStarPrinters();
            console.log('getPrintersResponse', getPrintersResponse);
            if (getPrintersResponse.data.printers) {
                printers = getPrintersResponse.data.printers;
                printers.forEach((printer) => {
                    printer.isEditMode = false;
                    printer.label_previous = printer.label;
                    printer.id_previous = printer.id;
                });
                this.setState({
                    printers,
                });
            }
            this.setMessage('','','');
        } catch (error) {
            console.log(error);
        }

        async function getStarPrinters() {
            return await ApiRequest(`/printers`, {
                method: 'GET',
            });
        }
    }

    registerPrinter = async () => {
        this.setMessage('', '', 'loading');
        let new_printer = this.state.new_printer;
        try {
            const registerResponse = await register(new_printer);
            console.log(registerResponse);
            if (registerResponse.data.printer) {
                this.setMessage(window.general_strings.msg.yay, `The printer ${registerResponse.data.printer.name} - ${registerResponse.data.printer.ip_address} has been registered successfully!`, 'success');
                new_printer.name = '';
                new_printer.ip_address = '';
                this.setState({
                    isShowAddPrinter: false,
                    new_printer,
                });
                setTimeout(() => {
                    this.getPrinters();
                }, 2000);
            } else {
                this.setMessage(window.general_strings.msg.oops, registerResponse.data.error.messageText, 'error');
            }

            setTimeout(() => {
                this.setMessage('', '', '');
            }, 3000);
        } catch (error) {
            console.log(error);
        }

		async function register(data) {
			return await ApiRequest(`/printers`, {
                method: 'POST',
                data,
            });
        }
    }

    toggleNewPrinter = () => {
        const isShowAddPrinter = this.state.isShowAddPrinter;
        this.setState({
            isShowAddPrinter: !isShowAddPrinter,
        });
    }

    deletePrinter = async (index) => {
        this.setMessage('', '', 'loading');
        let printers = this.state.printers;
        let selectedPrinter = this.state.selectedPrinter;
        try {
            const deleteResponse = await deleteP(printers[index]);
            console.log(deleteResponse);
            if (deleteResponse.data.success) {
                if (selectedPrinter === printers[index].ip_address) {
                    localStorage.removeItem('defaultStarPrinter');
                    selectedPrinter = '';
                }
                this.setMessage(window.general_strings.msg.yay, `The printer has been deleted!`, 'success');
                printers.splice(index, 1);
                this.setState({
                    printers,
                    selectedPrinter,
                });
                setTimeout(() => {
                    this.getPrinters();
                }, 2000);
            } else {
                this.setMessage(window.general_strings.msg.oops, deleteResponse.data.error.messageText, 'error');
            }
            setTimeout(() => {
                this.setMessage('', '', '');
            }, 3000);
        } catch (error) {
            console.log(error);
        }

		async function deleteP(printer) {
			return await ApiRequest(`/printers/${printer.id}`, {
                method: 'DELETE',
            });
        }
    }

    updatePrinter = async (index) => {
        this.setMessage('', '', 'loading');
        let printers = this.state.printers;
        try {
            const updateResponse = await update(printers[index]);
            console.log(updateResponse);
            if (updateResponse.data.printer) {
                this.setMessage(window.general_strings.msg.yay, `The printer has been updated!`, 'success');
                setTimeout(() => {
                    this.getPrinters();
                }, 4000);
            } else {
                this.setMessage(window.general_strings.msg.oops, updateResponse.data.error.messageText, 'error');
            }
            setTimeout(() => {
                this.setMessage('', '', '');
            }, 3000);
        } catch (error) {
            console.log(error);
        }

		async function update(printer) {
            let data = {};
            data.name = printer.name;
            data.ip_address = printer.ip_address;
			return await ApiRequest(`/printers/${printer.id}`, {
                method: 'PUT',
                data,
            });
        }
    }

    handleChangeNew = (e) => {
        e.persist();
        let value = e.target.value;
        const name = e.target.name;
        const new_printer = this.state.new_printer;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        new_printer[name] = value;
        this.setState({
            new_printer,
        });
    }

    handleChange = (e, index) => {
        e.persist();
        let value = e.target.value;
        const name = e.target.name;
        const printers = this.state.printers;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        printers[index][name] = value;
        this.setState({
            printers,
        });
    }

    setSelectedPrinter = (printer) => {
        let selectedPrinter = this.state.selectedPrinter;
        selectedPrinter = printer;
        this.setState({
            selectedPrinter,
        });
    }

    setDefaultPrinter = (printer) => {
        localStorage.setItem('defaultStarPrinter', printer.ip_address);
        this.setSelectedPrinter(printer.ip_address);
    }

    renderAddPrinter = () => {
        return (
            <React.Fragment>
                {!this.state.isShowAddPrinter && (
                    <button className="showtix-button showtix-background__primary-1" onClick={() => this.toggleNewPrinter()}>{strings.addPrinter}</button>
                )}
                <div className="row mt-4">
                    {this.state.isShowAddPrinter && (
                        <div className="col-12">
                            <h2>{strings.addPrinter}</h2>
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor={`name-new`}>{strings.name}</label>
                                        <div className="showtix-form__input">
                                            <input
                                                id={`name-new`}
                                                className="showtix-input"
                                                type="text"
                                                name="name"
                                                value={this.state.new_printer.name || ''}
                                                onChange={(e) => this.handleChangeNew(e)}
                                                placeholder={'mc-Print2 - Box Office'}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor={`ip-new`}>{strings.ip}</label>
                                        <div className="showtix-form__input">
                                            <input
                                                id={`ip-new`}
                                                className="showtix-input"
                                                type="text"
                                                name="ip_address"
                                                value={this.state.new_printer.ip_address || ''}
                                                onChange={(e) => this.handleChangeNew(e)}
                                                placeholder={'https://192.168.68.130'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="showtix-form__group">
                                <button className="showtix-button showtix-background__primary-2" onClick={() => this.registerPrinter()} disabled={this.state.new_printer.name === '' || this.state.new_printer.ip_address === ''}>{strings.save}</button>
                                <button className="showtix-button showtix-background__grey-1" onClick={() => this.toggleNewPrinter()}>{strings.cancel}</button>
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }

    renderPrinters = () => {
        return (
            <React.Fragment>
                <h2>{strings.existingPrinters}</h2>
                <div className="row mt-4">
                    {this.state.printers.map((printer, i) => (
                        <div className="col-12 col-md-6">
                            <div className="row">
                                <div className="col-12">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor={`name-${i}`}>{strings.name}</label>
                                        <div className="showtix-form__input">
                                            <input
                                                id={`name-${i}`}
                                                className="showtix-input"
                                                type="text"
                                                name="name"
                                                value={printer.name || ''}
                                                onChange={(e) => this.handleChange(e, i)}
                                                placeholder={'mc-Print2 - Box Office'}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor={`ip-${i}`}>{strings.ip}</label>
                                        <div className="showtix-form__input">
                                            <input
                                                id={`ip-${i}`}
                                                className="showtix-input"
                                                type="text"
                                                name="ip_address"
                                                value={printer.ip_address || ''}
                                                onChange={(e) => this.handleChange(e, i)}
                                                placeholder={'https://192.168.68.130'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="showtix-form__group">
                                <button className="showtix-button showtix-background__primary-2" onClick={() => this.updatePrinter(i)}>{strings.update}</button>
                                <button className="showtix-button showtix-background__grey-1" onClick={() => this.deletePrinter(i)}>{strings.delete}</button>
                                {this.state.selectedPrinter !== printer.ip_address && (
                                    <button
                                        className="showtix-button showtix-background__primary-4"
                                        onClick={() => this.setDefaultPrinter(printer)}
                                    >
                                        {strings.makeDefault}
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
            
        );
    }

    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>
                
                <div className="showtix-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8">
                                <h1>{strings.title}</h1>
                                {this.renderAddPrinter()}
                            </div>
                            <div className="col-md-4">
                                {strings.tips.map((help, i) =>
                                    <Help help={help} key={i} />
                                )}
                            </div>
                        </div>
                        {this.renderPrinters()}
                    </div>
                </div>
                
            </React.Fragment>
        );
    }
}

Star.propTypes = {
}

export default Star;



// WEBPACK FOOTER //
// ./src/components/Client/Star/Star.js